import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface AutocompleteRequest {
  input: string;
  locationBias?: object;
  includedRegionCodes?: string[];
  languageCode?: string;
  // Add more optional fields as needed
}

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesService {
  private readonly API_URL = 'https://places.googleapis.com/v1/places';
  // private readonly InterceptorSkipBearer = 'X-Skip-Authorization-Bearer';

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'X-Goog-Api-Key': environment.placesApiNewKey,
    // 'X-Goog-FieldMask': 'suggestions.placePrediction.text', // customize as needed
    googlePlacesSkipInterceptor: 'true', // Custom header to signal skipping
  });
  constructor(private http: HttpClient) {}

  getAutocompleteSuggestions(request: AutocompleteRequest): Observable<any> {
    return this.http.post(`${this.API_URL}:autocomplete`, request, { headers: this.headers });
  }

  getPlaceDetails(placeId: string): Observable<any> {
    const clonedHeaders = this.headers.set('X-Goog-FieldMask', 'id,displayName,addressComponents,formattedAddress,location');
    return this.http.get(`${this.API_URL}/${placeId}?languageCode=en`, { headers: clonedHeaders });
  }
}
